<template>
  <div>
    <b-row class="mb-1">
      <b-col cols="12">
        <h2>{{ $t('Data Export') }}</h2>
      </b-col>
    </b-row>
    <b-row align-v="start">
      <b-col cols="12" lg="4" class="mb-1 mb-lg-0">
        <ExportWizardCard @added="onExportAdded" />
      </b-col>
      <b-col cols="12" lg="8">
        <ExportHistoryCard ref="exportHistoryCard" />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import ExportWizardCard from '@/xvisor/components/export/ExportWizardCard.vue';
import ExportHistoryCard from '@/xvisor/components/export/ExportHistoryCard.vue';

export default {
  components: {
    ExportWizardCard,
    ExportHistoryCard,
  },
  methods: {
    onExportAdded() {
      if (this.$refs.exportHistoryCard) {
        this.$refs.exportHistoryCard.reload();
      }
    },
  },
};
</script>
